import { type CSSProperties } from 'react';
import { convertToCssPixelValue } from '~/utils';

export const calculateSafeArea = (value: CSSProperties['top'], position: 'top' | 'bottom' | 'right' | 'left') => {
  if (value === undefined) return undefined;
  return `calc(env(safe-area-inset-${position}) + ${convertToCssPixelValue(value)})`;
};
